import React from 'react';
import { Route, Navigate } from 'react-router-dom';

// Layout
import MentorsLayout from '../layouts/MentorLayout';

// Components
import ProtectedRoute from '../Components/ProtectedRoute';

// Pages
import MentorsIndex from '../Pages/Mentor/MentorDashboard';
import MentorsEvaluationList from '../Pages/Mentor/Evaluation/EvaluationList';
import MentorsEvaluationDetail from '../Pages/Mentor/Evaluation/EvaluationDetail';
import EvaluationHSAdd from '../Pages/Mentor/Evaluation/EvaluationHSAdd';
import EvaluationSSAdd from '../Pages/Mentor/Evaluation/EvaluationSSAdd';
import MentorsPATEvaluationReceivedDetail from '../Pages/Mentor/EvaluationPAT/PATEvaluationDetail';
import MentorsClassificationsHardskills from '../Pages/Mentor/Classifications/ClassificationsHardskills';
import MentorsClassificationsAdd from '../Pages/Mentor/Classifications/ClassificationsAdd';
import MentorsClassificationsUpdate from '../Pages/Mentor/Classifications/ClassificationsUpdate';
import RegistrationsList from '../Pages/Mentor/Registrations/RegistrationsList';
import RegistrationsDetail from '../Pages/Mentor/Registrations/RegistrationsDetail';
import MentorUsersList from '../Pages/Mentor/Mentees/MentorUsersList';
import AttendancesByMentor from '../Pages/Mentor/Attendances/AttendancesByMentor';
import AttendancesByMentorDetail from '../Pages/Mentor/Attendances/AttendancesByMentorDetail';
import AttendancesParticipantDetail from '../Pages/Mentor/Attendances/AttendancesParticipantDetail';
import MentorProfile from '../Pages/Mentor/Profile/MentorProfile';

const mentorRoutes = () => (
  <Route path='mentor'>
    {/* semua halaman setelah login, hanya role mentor yg bisa akses */}
    <Route element={<ProtectedRoute allowedRoles={['Mentor']} />}>
      <Route element={<MentorsLayout />}>
        <Route
          index
          element={<MentorsIndex />}
        />
        <Route
          path='home'
          element={
            <Navigate
              to='/mentor'
              replace
            />
          }
        />

        <Route path='registrations'>
          <Route
            index
            element={<RegistrationsList />}
          />
          <Route
            path=':id'
            element={<RegistrationsDetail />}
          />
        </Route>

        <Route path='mentees'>
          <Route
            path='evaluations'
            element={<MentorsEvaluationList />}
          />
          <Route path=':id/evaluations'>
            <Route
              index
              element={<MentorsEvaluationDetail />}
            />
            <Route
              path='new/hard-skill'
              element={<EvaluationHSAdd />}
            />
            <Route
              path='new/soft-skill'
              element={<EvaluationSSAdd />}
            />
            <Route
              path='pat/received'
              element={<MentorsPATEvaluationReceivedDetail />}
            />
          </Route>
          <Route
            path='students'
            element={<MentorUsersList />}
          />
        </Route>

        <Route path='classifications'>
          <Route
            index
            element={<MentorsClassificationsHardskills />}
          />
          <Route
            path='add'
            element={<MentorsClassificationsAdd />}
          />
          <Route
            path=':divisionInstitutionsId/update'
            element={<MentorsClassificationsUpdate />}
          />
        </Route>

        <Route path='attendances'>
          <Route
            index
            element={<AttendancesByMentor />}
          />
          <Route
            path=':id'
            element={<AttendancesByMentorDetail />}
          />
          <Route
            path='participants/:userId'
            element={<AttendancesParticipantDetail />}
          />
        </Route>

        <Route path='profile'>
          <Route
            index
            element={<MentorProfile />}
          />
        </Route>
      </Route>
    </Route>
  </Route>
);

export default mentorRoutes;
